<template>
<div>
  <p>{{id}}</p>
  <p>{{label}}</p>
  <p>{{name}}</p>
  <p>{{value}}</p>
  <p>{{answer}}</p>
  <p>{{targets}}</p>
  <button id="answer" @click="answer_question({value: '1', label: 'yes'})">answer</button>
  <button id="back" @click="question_back">back</button>
  <trees-question-target-vue></trees-question-target-vue>
</div>
</template>

<script>
import QuestionTarget from 'components/trees/QuestionTarget.vue'

export default {
  props: ['id', 'label', 'name', 'value', 'answer', 'targets'],
  computed: {
    answer_targets: function() {
      return this.targets[this.answer.value]
    }
  },
  components: {
    'trees-question-target-vue': QuestionTarget
  },
  methods: {
    answer_question: function(answer) {
      this.$emit('update:answer', answer);
      this.$emit('question_answer', this.id);
    },
    question_back: function() {
      this.$emit('update:answer', {value: '', label: ''});
      this.$emit('question_back', this.id);
    }
  }
}
</script>

<style scoped>

</style>